import { render, staticRenderFns } from "./LabeledSelect.vue?vue&type=template&id=3141b774&scoped=true"
import script from "./LabeledSelect.vue?vue&type=script&lang=ts"
export * from "./LabeledSelect.vue?vue&type=script&lang=ts"
import style0 from "./LabeledSelect.vue?vue&type=style&index=0&id=3141b774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3141b774",
  null
  
)

export default component.exports